var _path;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgInstagram(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    xmlns: "http://www.w3.org/2000/svg",
    viewBox: "0 0 24 24",
    fill: "currentColor",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M12 4.6c2.4 0 2.7 0 3.65.05.88.04 1.36.19 1.68.31.42.17.72.36 1.04.68.32.32.51.62.68 1.04.12.32.27.8.31 1.68C19.4 9.3 19.4 9.6 19.4 12s0 2.7-.05 3.65c-.04.88-.19 1.36-.31 1.68-.17.42-.36.72-.68 1.04-.32.32-.62.51-1.04.68-.32.12-.8.27-1.68.31-.95.05-1.24.05-3.64.05s-2.7 0-3.65-.05c-.88-.04-1.36-.19-1.68-.31a2.8 2.8 0 0 1-1.04-.68 2.8 2.8 0 0 1-.68-1.04c-.12-.32-.27-.8-.31-1.68C4.6 14.7 4.6 14.4 4.6 12s0-2.7.05-3.65c.04-.88.19-1.36.31-1.68.17-.42.36-.72.68-1.04a2.8 2.8 0 0 1 1.04-.68c.32-.12.8-.27 1.68-.31C9.3 4.6 9.6 4.6 12 4.6Zm0 4.1a3.3 3.3 0 1 0 0 6.6 3.3 3.3 0 0 0 0-6.6Zm0 5.44a2.14 2.14 0 1 1 0-4.28 2.14 2.14 0 0 1 0 4.28Zm4.2-5.57a.77.77 0 1 1-1.54 0 .77.77 0 0 1 1.54 0Z"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgInstagram);
export default __webpack_public_path__ + "static/media/instagram.0abe0cd8333d7f27b271a02e4bebe51d.svg";
export { ForwardRef as ReactComponent };